<div class="p-4">
  <h2 mat-dialog-title>Nova Observação</h2>
  
  <mat-dialog-content>
    <form [formGroup]="observacaoForm" class="mt-3">
      <mat-form-field class="w-100">
        <mat-label>Observação</mat-label>
        <textarea 
          matInput 
          formControlName="textoObservacao" 
          rows="4" 
          maxlength="500"
          placeholder="Digite sua observação aqui...">
        </textarea>
        <mat-hint align="end">
          {{ observacaoForm.get('textoObservacao')?.value?.length || 0 }}/500
        </mat-hint>
        <mat-error *ngIf="observacaoForm.get('textoObservacao')?.hasError('required')">
          Observação é obrigatória
        </mat-error>
        <mat-error *ngIf="observacaoForm.get('textoObservacao')?.hasError('minlength')">
          Observação deve ter pelo menos 5 caracteres
        </mat-error>
        <mat-error *ngIf="observacaoForm.get('textoObservacao')?.hasError('maxlength')">
          Observação não pode ter mais de 500 caracteres
        </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="loading">
      Cancelar
    </button>
    <button 
      mat-flat-button 
      color="primary" 
      (click)="onSave()" 
      [disabled]="!observacaoForm.valid || loading">
      <mat-spinner diameter="20" class="me-2" *ngIf="loading"></mat-spinner>
      Salvar
    </button>
  </mat-dialog-actions>
</div>
